require('es6-promise').polyfill()
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        access_token: localStorage.getItem('access_token') || '',
        user: localStorage.getItem('user') != 'undefined' ? JSON.parse(localStorage.getItem('user')) || null : null,
        permissions: localStorage.getItem('permissions') != 'undefined' ? JSON.parse(localStorage.getItem('permissions')) || [] : [],
        actions: [
            { value: 0, text: 'No' },
            { value: 1, text: 'Si' }
        ],
        accounts: [
            { value: 0, text: 'Sistema' },
            { value: 1, text: 'Personal' },
            { value: 2, text: 'Empresarial' },
        ],
        collapse: localStorage.getItem('collapse') || false,
        maxPage: false,
        tags: [],
        spinner: false,
        package: null,
    },
    mutations: {
        AUTH_INIT(state){
            state.status = 'LOADING'
        },
        AUTH_SUCCESS(state, data){
		    state.status = 'SUCCESS'
            state.access_token = data.token_type + ' ' + data.access_token
            state.user = data.user
            state.permissions = data.permissions
            localStorage.setItem('access_token', state.access_token)
            localStorage.setItem('user', JSON.stringify(data.user))
            localStorage.setItem('permissions', JSON.stringify(data.permissions))
            axios.defaults.headers.common['Authorization'] = state.access_token
        },
        AUTH_FINISH(state){
            state.status = ''
            state.user = null
            state.access_token = ''
            state.permissions = []
            localStorage.removeItem('tab_package_update')
            localStorage.removeItem('tab_user_update')
            localStorage.removeItem('access_token')
            localStorage.removeItem('permissions')
            localStorage.removeItem('collapse')
            localStorage.removeItem('navbar')
            localStorage.removeItem('user')
            delete axios.defaults.headers.common['Authorization']
        },
        ME_PROFILE(state, data){
		    state.status = 'SUCCESS'
            state.user = data
            localStorage.setItem('user', JSON.stringify(data))
        },
        ON_COLLAPSE(state, change = true){
            if(change){
                state.collapse = !state.collapse
            }else{
                state.collapse = false
            }
        },
        ON_MAXPAGE(state, change = true){
            if(change){
                state.maxPage = !state.maxPage
            }else{
                state.maxPage = false
            }
        },
        ADD_TAGS(state, item){
            let exist = state.tags.findIndex((e) => e.id == item.id)
            if(exist != -1){
                state.tags.splice(exist, 1, item)
            }else{
                state.tags.push(item)
            }
            if(state.tags.length > 4){
                state.tags.splice(0, 1)
            }
        },
        REMOVE_TAGS(state, index){
            state.tags.splice(index, 1)
        },
        ME_PERMISSIONS(state, data){
            state.permissions = data
            localStorage.setItem('permissions', JSON.stringify(data))
        },
        SAVE_PACKAGE(state, data){
            state.package = data
        }
    },
    actions: {
        PROFILE({commit}, data){
            commit('AUTH_INIT')
            commit('ME_PROFILE', data)
        },
        INIT_USER({commit}, data){
            commit('AUTH_INIT')
            commit('AUTH_SUCCESS', data)
        },
        FINISH_USER({commit}){
            commit('AUTH_INIT')
            commit('AUTH_FINISH')
        },
        COLLAPSE({commit}, change){
            commit('ON_COLLAPSE', change)
        },
        MAXPAGE({commit}, change){
            commit('ON_MAXPAGE', change)
        },
        ADD_TAGS({commit}, item){
            commit('ADD_TAGS', item)
        },
        REMOVE_TAGS({commit}, index){
            commit('REMOVE_TAGS', index)
        },
        PERMISSIONS({commit}, data){
            commit('ME_PERMISSIONS', data)
        },
        PACKAGE({commit}, data){
            commit('SAVE_PACKAGE', data)
        }
    },
    getters : {
        access_token: state => state.access_token,
        user: state => state.user,
        role: state => state.user.role_id,
        actions: state => state.actions,
        accounts: state => state.accounts,
        collapse: state => state.collapse,
        maxPage: state => state.maxPage,
        tags: state => state.tags,
        spinner: state => state.spinner,
        permissions: state => state.permissions,
        package: state => state.package,
    }
})



// WEBPACK FOOTER //
// ./src/stores/index.js